import { render, staticRenderFns } from "./SafetyAccidentNumberOfStaff.vue?vue&type=template&id=0ae562b2&scoped=true"
import script from "./SafetyAccidentNumberOfStaff.vue?vue&type=script&lang=js"
export * from "./SafetyAccidentNumberOfStaff.vue?vue&type=script&lang=js"
import style0 from "./SafetyAccidentNumberOfStaff.vue?vue&type=style&index=0&id=0ae562b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae562b2",
  null
  
)

export default component.exports